import React from 'react'
import PropTypes from 'prop-types';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { visuallyHidden } from '@mui/utils';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';

const ChannelTableHead = (props) => {
    const headCells = [
        {
            id: 'channel_type_id',
            numeric: false,
            disablePadding: true,
            label: 'Channel Type',
        },
        {
            id: 'channel_name ',
            numeric: false,
            disablePadding: true,
            label: 'CHANNEL',
        },
        {
            id: 'store_name',
            numeric: false,
            disablePadding: true,
            label: 'STORE NAME',
        },
        {
            id: 'shopify_app_token',
            numeric: false,
            disablePadding: true,
            label: 'APP TOKEN',
        },
        {
            id: 'webhook_url',
            numeric: false,
            disablePadding: true,
            label: 'Webhook URL',
        },
        {
            id: 'created_at',
            numeric: true,
            disablePadding: false,
            label: 'CREATED AT',
        },
        {
            id: 'updated_at',
            numeric: true,
            disablePadding: false,
            label: 'UPDATED AT',
        },
        {
            id: 'action',
            numeric: true,
            disablePadding: false,
            label: 'ACTION',
        },
    ];

    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {/* <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                'aria-label': 'select all desserts',
                            }}
                        />
                    </TableCell> */}
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={'left'}
                        // padding={'none'}
                        sx={{ fontSize: '0.75rem', padding: '3px 7px' }}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

ChannelTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
export default ChannelTableHead